var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1493_361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1384 6.01287C42.6779 0.0296575 48.9889 0.000488281 48.9889 0.000488281C48.9889 0.000488281 49.9277 5.62572 45.4179 11.0446C40.6026 16.8308 35.1293 15.884 35.1293 15.884C35.1293 15.884 34.1016 11.3334 38.1384 6.01287ZM35.7067 19.8244C38.0421 19.8244 42.3764 16.6142 48.0181 16.6142C57.7293 16.6142 61.5496 23.5244 61.5496 23.5244C61.5496 23.5244 54.0777 27.3447 54.0777 36.6143C54.0777 47.0714 63.3857 50.6752 63.3857 50.6752C63.3857 50.6752 56.879 68.989 48.0904 68.989C44.0538 68.989 40.9155 66.2688 36.6624 66.2688C32.3281 66.2688 28.0269 69.0905 25.2255 69.0905C17.2001 69.0907 7.06128 51.7181 7.06128 37.7534C7.06128 24.0141 15.6432 16.8067 23.6926 16.8067C28.9255 16.8067 32.9863 19.8244 35.7067 19.8244Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1493_361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.09,
    height: 69.09,
    fill: "white",
    transform: "translate(0.677979 0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.521b4554c1149db430f83fc1a4d3fc39.svg";
export { ForwardRef as ReactComponent };